<template>
    <div :class="context.classes.element" :data-type="context.type">
        <div class="relative max-w-input">
            <input
                type="text"
                v-model="context.model"
                v-bind="context.attributes"
                @blur="context.blurHandler"
                ref="signature_input"
                class="opacity-0 w-full h-full z-1 absolute"
            />
            <div
                class="w-full text-center rounded border p-2 cursor-pointer relative z-10"
                @click="openModal()"
            >
                <span v-if="context.model">Signed (click to re-sign)</span>
                <span v-else>Click to sign</span>
            </div>
        </div>

        <Modal title="Signature" ref="modal" max-w="lg">
            <div class="signature-wrapper border-2">
                <VueSignaturePad
                    class="signature"
                    ref="signature"
                ></VueSignaturePad>
            </div>
            <template v-slot:actions>
                <button type="button" @click="saveSignature()">
                    {{ $t("components.emails_edit.modal.save_button") }}
                </button>
                <button @click="closeModal()" class="text-gray-400">
                    {{ $t("components.emails_edit.modal.cancel_button") }}
                </button>
            </template>
        </Modal>
    </div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";
import Modal from "@/components/common/Modal";

export default {
    name: "SignaturePad",
    components: { Modal },
    computed: {
        usesDecorator() {
            return this.$formulate.options.useInputDecorators;
        }
    },
    methods: {
        openModal() {
            this.$refs.modal.open();
        },
        closeModal() {
            this.context.model = null;
            this.$refs.modal.close();
        },
        saveSignature() {
            let { isEmpty, data } = this.$refs.signature.saveSignature();
            if (!isEmpty) {
                this.context.model = data;
            }
            this.$refs.modal.close();
        }
    },
    mixins: [FormulateInputMixin]
};
</script>

<style scoped>
.max-w-input {
    max-width: 20em;
}
.signature-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
}
.signature-wrapper .signature {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.formulate-input .formulate-input-element {
    max-width: none !important;
}
</style>
